import { gql } from "@apollo/client";

export const VERIFY_TOKEN = gql`
query VerifyToken ($token: String!) {
  verifyToken(token: $token) {
    message
  }
}
`;
export const RESET_PASSWORD = gql`
mutation ResetPassword ($resetPasswordInput: ResetPasswordInput!) {
  resetPassword(resetPassword: $resetPasswordInput) {
    message
  }
}
`;
